import React, { Component } from "react";
import { NavItem, Nav, NavDropdown, MenuItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Url } from '../../shared/Url';
import Post from '../../shared/Post';
import {  NotifValidate, NotifValidateConEmail, cerrarSesion, Validate, ValidateInscrip, ValidateNotas,
          ValidateConstEst, ValidateAdmision, ValidatePago, ValidateEmail, ValidateRetiro,
          ValidateRetiroAdmin, ValidateConstEstAdmin, ValidateNotasAdmin, ValidateRetiroEst, ValidateSolEstAdmin,
          ValidateSolEst, ValidateCambCarrera} from '../../funciones/HeaderFunction';

let UType = 0;
let InvervaloCheckCorreo = 270000;
let requestUserName4 = false;

class HeaderLinks extends Component {
    state = {
        cantNotif : 0,
        cantNotifEmail : 0,
        cantNotifValidate: 0,
        cantNotifValidateInscrip: 0,
        cantNotifValidateCambCarrerra: 0,
        cantNotifValidateNotas: 0,
        cantNotifValidateConstEst: 0,
        cantNotifValidateAdmision: 0,
        cantNotifVerifyPago: 0,
        cantNotifRetiro: 0,
        cantNotiEmail: [],
        preloader: <React.Fragment><i className = "fa fa-spinner fa-spin"></i> Buscando mensajes sin leer</React.Fragment>,
        emails: 0,
        iconRefresh: { icon: "fa fa-refresh fa-spin", disabled: false },
        iconText: { icon: "", text: "" },
        cantNotifRetiroAdmin: 0,
        cantNotifValidateConstEstAdmin: 0,
        cantNotifValidateNotasAdmin: 0,
        cantNotifValidateRetiro: 0,
        cantNotifValidateSolEstAdmin: "",
        cantNotifValidateSolEst: "",
    }

    constructor (props) {
        super (props);
        this.consultaInicial()
    }

    consultaInicial = () => {
        if (requestUserName4 === true) return null;
        requestUserName4 = true;

        this.typeUser((resp) => {
            UType = resp
            switch(resp){
                case "":
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                    ValidateInscrip  ((resp) => { this.setState(resp) })
                    ValidateCambCarrera((resp) => { this.setState(resp) })
                    ValidateRetiro  ((resp) => { this.setState(resp) })
                    ValidateConstEst  ((resp) => { this.setState(resp) })
                    ValidateSolEst  ((resp) => { this.setState(resp) })
                break
                case 3:
                    NotifValidate  ((resp) => {
                        this.setState(resp)
                    })
                    Validate  ((resp) => { this.setState(resp) })
                    ValidateInscrip  ((resp) => { this.setState(resp) })
                    ValidateCambCarrera((resp) => { this.setState(resp) })
                    ValidateNotas  ((resp) => { this.setState(resp) })
                    ValidateRetiro  ((resp) => { this.setState(resp) })
                    ValidateConstEst  ((resp) => { this.setState(resp) })
                    ValidateSolEst  ((resp) => { this.setState(resp) })
                break
                case 4:
                    NotifValidate  ((resp) => {
                        this.setState(resp)
                    })
                    ValidateAdmision  ((resp) => { this.setState(resp) })
                    ValidatePago  ((resp) => { this.setState(resp) })
                    ValidateRetiroAdmin  ((resp) => { this.setState(resp) })
                    ValidateConstEstAdmin  ((resp) => { this.setState(resp) })
                    ValidateNotasAdmin  ((resp) => { this.setState(resp) })
                    ValidateRetiroEst  ((resp) => { this.setState(resp) })
                    ValidateSolEstAdmin  ((resp) => { this.setState(resp) })
                break
                case 5:
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                break;
                case 6:
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                break;
                default: return null
            }
        })
    }

    typeUser = (respuesta) => {
        let leerCookie = (nombre) => {
            let lista = document.cookie.split(";");
            let micookie;
            let igual;
            let valor;
            for (let i in lista) {
              let busca = lista[i].search(nombre);
              if (busca > -1) {micookie=lista[i]}
            }
            
            if (micookie === undefined) return null;
            
            igual = micookie.indexOf("=");
            valor = micookie.substring(igual + 1);
            return valor;
        }
    
        let valor = leerCookie("S_ID")
        let valor2 = leerCookie("U_ID");

        let Content = {
            sId: valor,
            uId: valor2,
        }
    
        Post(`${Url}userName`, Content, (resp) => {
            requestUserName4 = false
            let data = JSON.parse(resp);
            respuesta(data.user_003);
        });
    }

    updNotif = () => () => {

        if (this.state.iconRefresh.disabled === true) return null;
        this.setState({
            iconRefresh: {icon: "fa fa-refresh fa-spin", disabled: true},
            iconText: { icon: "fa fa-spinner fa-spin", text: "Buscando notificaciones nuevas" }
        }, () => {
            switch(UType){
                case "":
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                    ValidateInscrip  ((resp) => { this.setState(resp) })
                    ValidateCambCarrera((resp) => { this.setState(resp) })
                    ValidateNotas  ((resp) => { this.setState(resp) })
                    ValidateRetiro  ((resp) => { this.setState(resp) })
                    ValidateConstEst  ((resp) => { this.setState(resp) })
                    ValidateSolEst  ((resp) => { this.setState(resp) })
                break
                case 3:
                    NotifValidate  ((resp) => {
                        this.setState(resp)
                    })
                    Validate  ((resp) => { this.setState(resp) })
                    ValidateInscrip  ((resp) => { this.setState(resp) })
                    ValidateCambCarrera((resp) => { this.setState(resp) })
                    ValidateNotas  ((resp) => { this.setState(resp) })
                    ValidateRetiro  ((resp) => { this.setState(resp) })
                    ValidateConstEst  ((resp) => { this.setState(resp) })
                    ValidateSolEst  ((resp) => { this.setState(resp) })
                break
                case 4:
                    NotifValidate  ((resp) => {
                        this.setState(resp)
                    })
                    ValidateAdmision  ((resp) => { this.setState(resp) })
                    ValidatePago  ((resp) => { this.setState(resp) })
                    ValidateRetiroAdmin  ((resp) => { this.setState(resp) })
                    ValidateConstEstAdmin  ((resp) => { this.setState(resp) })
                    ValidateNotasAdmin  ((resp) => { this.setState(resp) })
                    ValidateRetiroEst  ((resp) => { this.setState(resp) })
                    ValidateSolEstAdmin  ((resp) => { this.setState(resp) })
                break
                case 5:
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                break;
                case 6:
                    NotifValidate  ((resp) => { this.setState(resp) })
                    Validate  ((resp) => { this.setState(resp) })
                break;
                default: return null
            }
        })
    }

    /* ----------- NOTIFICACIONES ----------- */
    notifValidate = () => {
        if (this.state.cantNotifValidate === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "perfil";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidate > 1) {
            texto1 = "solicitudes";
            texto2 = "perfiles";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/perfiles_pendientes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidate} {texto1}</strong> de aprobación de {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }
    
    notifValidateCambarrera = () => {
        if (this.state.cantNotifValidateCambCarrerra === 0) return null;

        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateCambCarrerra > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/registros/estudiantes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateCambCarrerra} {texto1}</strong> de <span className = "text-danger"> <strong>CAMBIO DE CARRERA</strong></span> {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateInscrip = () => {
        if (this.state.cantNotifValidateInscrip === 0) return null;
        let texto1 = "inscripción";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateInscrip > 1) {
            texto1 = "inscripciones";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/inscripciones_pendientes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateInscrip} <span className = "text-danger">{texto1.toUpperCase()}</span></strong> {texto2} de aprobación.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateNotas = () => {
        if (this.state.cantNotifValidateNotas === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateNotas > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/reportes/notas_certificadas">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateNotas} {texto1}</strong> de Notas {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateNotasAdmin = () => {
        if (this.state.cantNotifValidateNotasAdmin === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateNotasAdmin > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/admin_solicitudes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateNotasAdmin} {texto1}</strong> de Notas {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateConstEst = () => {
        if (this.state.cantNotifValidateConstEst === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateConstEst > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/reportes/constancia_estudios">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateConstEst} {texto1}</strong> de <strong className = "text-danger">CONSTANCIA DE ESTUDIOS (SIMPLE)</strong> {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateConstEstAdmin = () => {
        if (this.state.cantNotifValidateConstEstAdmin === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateConstEstAdmin > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/admin_solicitudes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateConstEstAdmin} {texto1}</strong> de <strong className = "text-danger">CONSTANCIA DE ESTUDIOS (SIMPLE)</strong> {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateSolEstAdmin = () => {
        let { cantNotifValidateSolEstAdmin } = this.state;
        if (cantNotifValidateSolEstAdmin === "") return null;
        if (this.state.cantNotifValidateSolEstAdmin.length === 0) return null;

        let text = (cant, textS, textP) => {
            if(cant <= 1) return textS;
            return textP;
        }

        return (
            cantNotifValidateSolEstAdmin.map(option => (
                <MenuItem eventKey={2.0} key = {option.id}>
                    <NavLink to="/admin_solicitudes">
                        <div style={{fontSize: 11}}>
                            <div>Tienes <strong>{option.cant} {text(option.cant, "solicitud", "solicitudes")}</strong> de <strong className = "text-danger">{option.item}</strong> {text(option.cant, "pendiente", "pendientes")}.</div>
                            <div>Haz click aqui para {text(option.cant, "revisarla", "revisarlas")}</div>
                        </div>
                    </NavLink>
                </MenuItem> 
            )) 
        )
    }

    notifValidateSolEst = () => {
        let { cantNotifValidateSolEst } = this.state;
        if (cantNotifValidateSolEst.length === 0) return null;
        if (cantNotifValidateSolEst === "") return null;

        let text = (cant, textS, textP) => {
            if(cant <= 1) return textS;
            return textP;
        }

        let link = (tipo) => {
            switch(tipo){
                case "CARTA DE EGRESO": return "carta_egreso";
                case "CARGA HORARIA": return "carga_horaria";
                case "CERTIFICACION PLAN DE ESTUDIOS (PENSUM)": return "pensum_programas";
                case "CONSTANCIA DE MODALIDAD DE ESTUDIO (SIMPLE)": return "mod_estudios_simple";
                case "CONSTANCIA DE MODALIDAD DE ESTUDIO (CERTIFICADA)": return "mod_estudios_cert";
                case "CONSTANCIA DE CULMINACION DE ESTUDIOS (SIMPLE)": return "culminacion_est_dir";
                case "CONSTANCIA DE CULMINACION DE ESTUDIOS (CERTIFICADA)": return "culminacion_est_cert_dir";
                case "CONSTANCIA DE BUENA CONDUCTA (CERTIFICADA)": return "constancia_conducta_cert_dir";
                default: return ""; 
            }
        }

        return (
            cantNotifValidateSolEst.map(option => (
                <MenuItem eventKey={2.0} key = {option.id}>
                    <NavLink to= {`/reportes/${link(option.item)}`}>
                        <div style={{fontSize: 11}}>
                            <div>Tienes <strong>{option.cant} {text(option.cant, "solicitud", "solicitudes")}</strong> de <strong className = "text-danger">{option.item}</strong> {text(option.cant, "pendiente", "pendientes")}.</div>
                            <div>Haz click aqui para {text(option.cant, "revisarla", "revisarlas")}</div>
                        </div>
                    </NavLink>
                </MenuItem> 
            )) 
        )
    }

    notifValidateAdmision = () => {
        if (this.state.cantNotifValidateAdmision === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifValidateAdmision > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
              <NavLink to="/admision_admin/consignacion">
                <div style={{fontSize: 11}}>
                    <div>Tienes <strong>{this.state.cantNotifValidateAdmision} {texto1}</strong> de Admisión {texto2}.</div>
                    <div>Haz click aqui para {texto3}</div>
                </div>
              </NavLink>
            </MenuItem>
        )
    }
    
    notifValidatePago = () => {
        if (this.state.cantNotifVerifyPago === 0) return null;
        let texto1 = "verificación";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifVerifyPago > 1) {
            texto1 = "verificaciones";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/estados_de_cuenta/verificacion_pago">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifVerifyPago} {texto1}</strong> de Pago {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateRetiro = () => {
        if (this.state.cantNotifRetiro === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifRetiro > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/registros/retiro_materias">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifRetiro} {texto1}</strong> de Retiro de Materia {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateRetiroEst = () => {
        if (this.state.cantNotifValidateRetiro === 0) return null;
        let texto1 = "nuevo";
        let texto2 = "retiro";
        let texto3 = "verlo";
        if (this.state.cantNotifValidateRetiro > 1) {
            texto1 = "nuevos";
            texto2 = "retiros";
            texto3 = "verlos";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/admin_solicitudes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifValidateRetiro} {texto1}</strong> {texto2} sin revisar.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notifValidateRetiroAdmin = () => {
        if (this.state.cantNotifRetiroAdmin === 0) return null;
        let texto1 = "solicitud";
        let texto2 = "pendiente";
        let texto3 = "revisarla";
        if (this.state.cantNotifRetiroAdmin > 1) {
            texto1 = "solicitudes";
            texto2 = "pendientes";
            texto3 = "revisarlas";
        }

        return (
            <MenuItem eventKey={2.0}>
                <NavLink to="/admin_solicitudes">
                    <div style={{fontSize: 11}}>
                        <div>Tienes <strong>{this.state.cantNotifRetiroAdmin} {texto1}</strong> de Retiro de Materia {texto2}.</div>
                        <div>Haz click aqui para {texto3}</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }
    /* -------------------------------------- */
    
    notificacionesPush = () => {
        let {cantNotif, iconRefresh, iconText} = this.state;

        let notifVacio = () => {
            /* if(cantNotif > 0) return null */

            return (
                <div style={{fontSize: 11}} align="center"><i className={iconText.icon}></i> {iconText.text}</div>
            )
        }

        let notification = () => {
            if(cantNotif === 0){
                if (this.props.tUser === "EST") return null;

                return (
                    <div title = "Consulta las notificaciones">
                        <i className={iconRefresh.icon} style={{color: "#a80012"}}/>
                    </div>
                )
            }else{
                return (
                    <div title = "Notificaciones">
                        <i className="fa fa-bell" style={{color: "#317373"}}/>
                        <b className="caret" />
                        <span className="notification" style={{backgroundColor: "#a80012"}}>{cantNotif}</span>
                        <p className="hidden-lg hidden-md">Notificaciones</p>
                    </div>
                )
            }
        }
        
        return (
            <NavDropdown eventKey={2} title={notification()} noCaret id="basic-nav-dropdown" onClick={this.updNotif()}>
                {notifVacio()}
                {this.notifValidate()}
                {this.notifValidateInscrip()}
                {this.notifValidateCambarrera()}
                {this.notifValidateNotas()}
                {this.notifValidateAdmision()}
                {this.notifValidateRetiro()}
                {this.notifValidatePago()}
                {this.notifValidateRetiroAdmin()}
                {this.notifValidateConstEstAdmin()}
                {this.notifValidateNotasAdmin()}
                {this.notifValidateRetiroEst()}
                {this.notifValidateConstEst()}
                {this.notifValidateSolEstAdmin()}
                {this.notifValidateSolEst()}
            </NavDropdown>
        )
    }

    notificationEmail = () => {
        let {emails} = this.state;

        if (emails === 0) return (
            <div title = "Mis Correos">
              <i className="fa fa-envelope" style={{color: "#f6a72f"}}/>
              <b className="caret" style = {{marginLeft: 6}}/>
            </div>
        )

        return (
            <div title = "Mis Correos">
              <i className="fa fa-envelope" style={{color: "#f6a72f"}}/>
              <span className="notification" style={{backgroundColor: "#a80012"}}>{emails}</span>
              <b className="caret" style = {{marginLeft: 6}}/>
            </div>
        )
    }

    notifEmails = () => {
        if (this.state.cantNotiEmail.length === 0) return null

        let emails = () => {
            let emailsNuevos = this.state.cantNotiEmail;
      
            return(
              emailsNuevos.map(option => (
                  <div key = {(Math.random() * 999999) + 1} style={{paddingLeft: 5}}>
                      <i className="fa fa-envelope" style={{color:"f6a72f"}}></i> <strong>({option.cantEm}) - {option.email}</strong>
                  </div>
              ))
            )
        }

        return (
            <MenuItem eventKey={2.1}>
                <NavLink to="/email">
                    <div style={{fontSize: 11}}>
                        <div>Tienes correos sin leer:</div>
                        {emails()}
                        <div style={{fontSize: 9}} className="text-muted">Haz click aqui para revisar tu(s) bandeja(s)</div>
                    </div>
                </NavLink>
            </MenuItem>
        )
    }

    notificacionesEmailPush = () => (
        <NavDropdown eventKey={2} title={this.notificationEmail()} noCaret id="basic-nav-dropdown">
            <div style = {{padding: 10}}>
                <NavLink to="/email" style={{fontSize:12, color:"#000"}}><i className="fa fa-envelope" style={{color:"#ef7831"}}></i> Mis Correos</NavLink>
            </div>
            {this.notifEmails()}
        </NavDropdown>
    )

    render() {

        let menus = () => {
            let tipo = this.props.tUser;
            switch (tipo) {
              case "EST": return "Estudiante";
              case "PROF": return "Profesor";
              case "DIR": return "Directivo";
              case "ADMIN": return "Administrador";
              case "WEBMASTER": return "Web Master";
              case "CONSULTA": return "Consulta";
              default: return "Error"
            }
        }

        let contenidoPerfil = () => (
            <React.Fragment>
                <div style={{fontSize:13, color:"#a80012"}}><strong>{this.props.userName}</strong></div>
                <div style={{fontSize:11, color:"#424242", marginTop: -10,}}><i className="fa fa-caret-down" style={{fontSize: 10}}> </i>Has ingresado como <strong>{menus()}</strong></div>
            </React.Fragment>
        )

        switch (true) {
            case(UType === 0):
                this.consultaInicial()
                return (
                    <div style={{height: 63}}>
                        <Nav className="col-lg-8 col-md-8">
                            <NavItem eventKey={3} style={{width:"100%"}}>

                            </NavItem>
                        </Nav>
                        <Nav pullRight style={{marginTop:8, paddingRight:5}}>
                            {this.notificacionesPush()}
                            <NavDropdown eventKey={2} noCaret={true} id="basic-nav-dropdown-right" align="right" 
                            title={ <span align="right">{contenidoPerfil()}</span> }>
                                <MenuItem eventKey={2.1}>
                                    <NavLink to="/perfil" style={{fontSize:12, color:"#000"}}><i className="fa fa-user-circle-o" style={{color:"#1f2f6e"}}></i> Mi Perfil</NavLink>
                                </MenuItem>
                                <MenuItem eventKey={2.2}>
                                    <NavLink to="/change_pass" style={{fontSize:12, color:"#000"}}><i className="fa fa-key" style={{color:"#1f2f6e"}}></i> Cambiar Contraseña</NavLink>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey={2.5} onClick = {cerrarSesion}><i className="fa fa-power-off" style={{color:"#A0555C"}}></i> Cerrar Sesión</MenuItem>
                            </NavDropdown>
                        </Nav>
                    </div>
                )
            case(UType === 1 || UType === 5):
                return (
                    <div style={{height: 63}}>
                        <Nav className="col-lg-8 col-md-8">
                            <NavItem eventKey={3} style={{width:"100%"}}>

                            </NavItem>
                        </Nav>
                        <Nav pullRight style={{marginTop:8, paddingRight:5}}>
                            {this.notificacionesPush()}
                            <NavDropdown eventKey={2} noCaret={true} id="basic-nav-dropdown-right" align="right"
                            title={ <span align="right">{contenidoPerfil()}</span> }>
                                <MenuItem eventKey={2.1}>
                                    <NavLink to="/perfil" style={{fontSize:12, color:"#000"}}><i className="fa fa-user-circle-o" style={{color:"#1f2f6e"}}></i> Mi Perfil</NavLink>
                                </MenuItem>
                                <MenuItem eventKey={2.2}>
                                    <NavLink to="/change_pass" style={{fontSize:12, color:"#000"}}><i className="fa fa-key" style={{color:"#1f2f6e"}}></i> Cambiar Contraseña</NavLink>
                                </MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey={2.5} onClick = {cerrarSesion}><i className="fa fa-power-off" style={{color:"#A0555C"}}></i> Cerrar Sesión</MenuItem>
                            </NavDropdown>
                        </Nav>
                    </div>
                )
            default: return (
                <div style={{height: 63}}>
                    <Nav className="col-lg-8 col-md-8">
                        <NavItem eventKey={3} style={{width:"100%"}}>

                        </NavItem>
                    </Nav>
                    <Nav pullRight style={{marginTop:8, paddingRight:5}}>
                        {this.notificacionesPush()}
                        {this.notificacionesEmailPush()}
                        <NavDropdown eventKey={2} noCaret={true} id="basic-nav-dropdown-right" align="right"
                        title={ <span align="right">{contenidoPerfil()}</span> }>
                            <MenuItem eventKey={2.1}>
                                <NavLink to="/perfil" style={{fontSize:12, color:"#000"}}><i className="fa fa-user-circle-o" style={{color:"#1f2f6e"}}></i> Mi Perfil</NavLink>
                            </MenuItem>
                            <MenuItem eventKey={2.2}>
                            <NavLink to="/change_pass" style={{fontSize:12, color:"#000"}}><i className="fa fa-key" style={{color:"#1f2f6e"}}></i> Cambiar Contraseña</NavLink>
                            </MenuItem>
                            <MenuItem divider />
                            <MenuItem eventKey={2.5} onClick = {cerrarSesion}><i className="fa fa-power-off" style={{color:"#A0555C"}}></i> Cerrar Sesión</MenuItem>
                        </NavDropdown>
                    </Nav>
                </div>
            )
        }
    }
}

export default HeaderLinks;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx